<!-- 产品信息 -->
<template>
    <div class="container">
        <div class="header">
            <Input class="w200 mr24 mb24" type="text" v-model="storePrams.name" placeholder="请输入商品名称"></Input>
            <Select class="w200 mr24 mb24" v-model="storePrams.type_id" clearable filterable placeholder="所有分类">
                <Option v-for="item in typeList" :value="item.id" :key="item.id">{{ item.type_name }}</Option>
            </Select>
            <Button class="theme-bc mb24 theme-default-color" icon="ios-search" @click="goSearch">确认搜索</Button>
        </div>
        <div class="content">
            <Button class="theme-bc mb24 theme-default-color" icon="md-add-circle" @click="goDrawer">新增产品</Button>
            <!-- 产品表格 -->
            <Table ref="selection" :columns="columnsTable" :data="dataTable" border @on-selection-change="changeSelection">
                <template slot-scope="{ row }" slot="show_product_imgs">
                    <div class="flex-c">
                        <img class="table_picture" v-if="row.show_product_imgs" :src="row.show_product_imgs[0]"/>
                    </div>
                </template>
                <template slot-scope="{ row }" slot="name">
                    <div>
                        {{ row.name }}<br/>
                        ID：{{ row.id }}<br/>
                        规格：{{ row.specs }}
                    </div>
                </template>
                <template slot-scope="{ row }" slot="price">
                    <div>￥：{{ row.price }}</div>
                </template>
                <template slot-scope="{ row }" slot="type">
                    <div>{{ row.type ? row.type.type_name : "" }}</div>
                </template>
                <template slot-scope="{ row }" slot="template_type">
                    <div class="flex-c" @click="goModal(1, row)">
                        <template v-if="row.template_type == 0">
                            <Button v-if="row.old_template" type="success">{{ row.old_template.title }}</Button>
                            <Button v-else>选择模板</Button>
                        </template>
                        <template v-else-if="row.template_type == 1">
                            <Button v-if="row.product_template" type="success">{{ row.product_template.title }}</Button>
                            <Button v-else>选择模板</Button>
                        </template>
                        <template v-else-if="row.template_type == 2">
                            <Button v-if="row.diy_template" type="success">{{ row.diy_template.title }}</Button>
                            <Button v-else>选择模板</Button>
                        </template>
                    </div>
                </template>
                <template slot-scope="{ row }" slot="show_report_imgs">
                    <div class="flex-c" @click="goReport(row)">
                        <Button v-if="row.show_report_imgs.length" type="success" ghost>已添加（{{ row.show_report_imgs.length }}）</Button> 
                        <Button v-else>未添加</Button>
                    </div>
                </template>
                <template slot-scope="{ row }" slot="product_pic_count">
                    <div class="flex-c" @click="goPic(row)">
                        <Button v-if="row.product_pic_count" type="success" ghost>已添加（{{ row.product_pic_count }}）</Button>
                        <Button v-else>未添加</Button>
                    </div>
                </template>
                <template slot-scope="{ row }" slot="attribute_content">
                    <div class="flex-c" @click="goAttribute(row)">
                        <Button v-if="row.attribute.length" type="success" ghost>已设置</Button>
                        <Button v-else>未设置</Button>
                    </div>
                </template>
                <template slot-scope="{ row }" slot="operate">
                    <div class="flex-sa">
                        <Button type="primary" ghost @click="goDrawer(row)">编辑</Button>
                        <Button type="error" ghost @click="goDel(1, row)">删除</Button>
                    </div>
                </template>
            </Table>
            <div class="page">
                <div>
                    <Checkbox class="checkbox-ml" v-model="del_value" @on-change="handleSelectAll">全选</Checkbox>
                    <span class="mr24 ml24">已经选择{{ delData.length }}个</span>
                    <Button type="error" ghost @click="goDel(0)">删除</Button>
                </div>
                <Page :current="storePrams.page" :page-size="storePrams.limit" :total="total" show-elevator show-total @on-change="pageChange"/>
            </div>
        </div>
        <!-- 新增/编辑 -->
        <Drawer v-model="drawers" :title="drawerTitle" width="1000">
            <Form :model="formData" label-position="right" :label-width="130">
                <FormItem label="产品名称：">
                    <Input class="w200" type="text" v-model="formData.product_name" placeholder="填写产品名称"></Input>
                </FormItem>
                <FormItem label="产品规格：">
                    <Input class="w200" type="text" v-model="formData.specs" placeholder="填写产品规格"></Input>
                </FormItem>
                <FormItem label="产品图片：">
                    <div>
                        <div class="form_upload mb24" @click="openModal(0, 1)">
                            <Icon type="ios-add" size="40" color="#AEAEB3" />
                        </div>
                        <draggable
                            class="dragg_div"
                            v-model="itemData.show_product_imgs"
                            chosen-class="chosen"
                            force-fallback="true"
                            group="people"
                            animation="500"
                            :handle="'.dragg'"
                            @start="onStart"
                            @end="onEnd"
                        >
                            <div
                                v-for="(
                                    item, index
                                ) in itemData.show_product_imgs"
                                :key="index"
                            >
                                <div
                                    class="form_upload mr24 mb24 position_relative dragg"
                                >
                                    <Icon
                                        class="form_icon"
                                        size="20"
                                        type="ios-close-circle"
                                        color="#f00"
                                        @click="delImg(1, index)"
                                    />
                                    <img class="width_height_100 br-5" :src="item" />
                                </div>
                            </div>
                        </draggable>
                    </div>
                </FormItem>
                <FormItem label="质保期：">
                    <Input class="w200" type="text" v-model="formData.warranty_days" placeholder="请输入质保期"><span slot="append">天</span></Input>
                </FormItem>
                <FormItem label="产品简介：">
                    <Input
                        class="width_800"
                        type="textarea"
                        v-model="formData.content"
                        :autosize="{ minRows: 3 }"
                        placeholder="输入产品简介"
                    ></Input>
                </FormItem>
                <FormItem label="建议零售价：">
                    <Input
                        class="w200"
                        type="number"
                        v-model="formData.price"
                        prefix="logo-yen"
                        placeholder="填写产品价格"
                    ></Input>
                </FormItem>
                <FormItem label="产品分类：">
                    <Select
                        class="w200"
                        v-model="formData.type_id"
                        clearable
                        filterable
                        placeholder="请选择产品分类"
                    >
                        <Option
                            v-for="item in typeList"
                            :value="item.id"
                            :key="item.id"
                            >{{ item.type_name }}</Option
                        >
                    </Select>
                </FormItem>
                <FormItem label="使用模板：">
                    <div class="form_div">
                        <Button @click="goModal(2, formData)">
                            <span v-if="formData.template_id">{{
                                itemData.template_title
                                    ? itemData.template_title
                                    : "选择模板"
                            }}</span>
                            <span v-else>选择模板</span>
                        </Button>
                        <Tooltip
                            max-width="250"
                            placement="right"
                            theme="light"
                        >
                            <Icon
                                class="ml24 cursor-p"
                                type="md-help-circle"
                                size="20"
                                color="#FF761D "
                            />
                            <div slot="content">
                                <p>添加模板说明：</p>
                                <p>
                                    1、请先在模板和链接栏目中，安装模板,然后进行相关配置。
                                </p>
                                <p>
                                    2、如果模板标明了产品类型(如农药溯源模板)，则代表该模板是专用模板，需配合产品及产品关联属性使用。
                                </p>
                                <p>
                                    3、如果未标明产品类型，则为通用型模板，可应用于任何产品上。
                                </p>
                            </div>
                        </Tooltip>
                    </div>
                </FormItem>
                <div class="mb24 form_title">查询结果提示</div>
                <FormItem label="首次查询提示：">
                    <editor
                        class="width_800"
                        :edtor-con="formData.first_query"
                        :index="1"
                        @getContent="getEnContent1"
                        @getContentchange="getEnContentchange1"
                    />
                </FormItem>
                <FormItem label="非首次查询提示：">
                    <editor
                        class="width_800"
                        :edtor-con="formData.not_first_query"
                        :index="2"
                        @getContent="getEnContent2"
                        @getContentchange="getEnContentchange2"
                    />
                </FormItem>
                <FormItem label="超额查询提示：">
                    <editor
                        class="width_800"
                        :edtor-con="formData.excess_query"
                        :index="3"
                        @getContent="getEnContent3"
                        @getContentchange="getEnContentchange3"
                    />
                </FormItem>
                <FormItem>
                    <div class="ta-r">
                        <Button @click="cancelDrawer">取消</Button>
                        <Button
                            class="theme-bc ml24 theme-default-color"
                            @click="submitDrawer"
                            >确认</Button
                        >
                    </div>
                </FormItem>
            </Form>
        </Drawer>
        <!-- 质检报告 -->
        <Modal
            v-model="reportModal"
            title="质检报告"
            width="500"
            :mask-closable="false"
        >
            <div>
                <Form
                    :model="reportData"
                    label-position="right"
                    :label-width="100"
                >
                    <FormItem label="质检报告：">
                        <Input
                            type="text"
                            v-model="reportData.report_name"
                            placeholder="请输入质检报告名称"
                        ></Input>
                        <div class="mt24">
                            <div
                                class="form_upload mb24"
                                @click="openModal(0, 2)"
                            >
                                <Icon
                                    type="ios-add"
                                    size="40"
                                    color="#AEAEB3"
                                />
                            </div>
                            <draggable
                                class="dragg_div"
                                v-model="itemData.show_report_imgs"
                                chosen-class="chosen"
                                force-fallback="true"
                                group="people"
                                animation="500"
                                :handle="'.dragg'"
                                @start="onStart"
                                @end="onEnd"
                            >
                                <div
                                    v-for="(
                                        item, index
                                    ) in itemData.show_report_imgs"
                                    :key="index"
                                >
                                    <div
                                        class="form_upload mr24 mb24 position_relative dragg"
                                    >
                                        <Icon
                                            class="form_icon"
                                            size="20"
                                            type="ios-close-circle"
                                            color="#f00"
                                            @click="delImg(2, index)"
                                        />
                                        <img
                                            class="width_height_100"
                                            :src="item"
                                            @click="openImg(item)"
                                        />
                                    </div>
                                </div>
                            </draggable>
                        </div>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button @click="cancelReportModal">取消</Button>
                <Button
                    class="theme-bc theme-default-color"
                    @click="submitReportModal"
                    >确定</Button
                >
            </div>
        </Modal>
        <!-- 产品样册 -->
        <Modal
            v-model="picModal"
            title="产品样册"
            width="60"
            :mask-closable="false"
        >
            <div>
                <Button
                    class="theme-bc mb24 theme-default-color"
                    icon="md-add-circle"
                    @click="goAddSample"
                    >添加产品样册</Button
                >
                <Table :columns="columnsPic" :data="dataPic" border>
                    <template slot-scope="{ row }" slot="show_cover">
                        <div class="flex-c">
                            <img class="table_picture" :src="row.show_cover" />
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <div class="flex-sa">
                            <Button
                                type="primary"
                                ghost
                               
                                @click="goAddSample(row)"
                                >编辑</Button
                            >
                            <Button
                                type="error"
                                ghost
                               
                                @click="goDel(2, row)"
                                >删除</Button
                            >
                        </div>
                    </template>
                </Table>
                <div class="page_div">
                    <Page
                        :current="pagePic.page"
                        :page-size="pagePic.limit"
                        :total="totalPic"
                        show-elevator
                        show-total
                        @on-change="pageChangePic"
                    />
                </div>
            </div>
            <div slot="footer"></div>
        </Modal>
        <!-- 产品属性 -->
        <Modal v-model="attributeModal" title="产品属性" width="600" :mask-closable="false" >
            <div>
                <Table :columns="columnsAttr" :data="dataAttr" border>
                    <template slot-scope="{ row }" slot="title">
                        <div>{{ row.page ? row.page.title : "" }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="operate">
                        <Button type="primary" ghost @click="goAttr(row)" >编辑</Button >
                    </template>
                </Table>
                <div class="page_div">
                    <Page :current="pageAttr.page" :page-size="pageAttr.limit" :total="totalAttr" show-elevator show-total @on-change="pageChangeAttr" />
                </div>
            </div>
            <div slot="footer"></div>
        </Modal>
        <!-- 新增产品样册 -->
        <Modal
            v-model="sampleModal"
            title="新增产品样册"
            width="500"
            :mask-closable="false"
        >
            <div>
                <Form
                    :model="formSample"
                    label-position="right"
                    :label-width="100"
                >
                    <FormItem label="样册名称：">
                        <Input
                            type="text"
                            v-model="formSample.title"
                            placeholder="请输入产品样册名称"
                        ></Input>
                    </FormItem>
                    <FormItem label="封面图：">
                        <div class="form_upload" @click="openModal(1)">
                            <img
                                class="width_height_100"
                                v-if="itemData.show_cover"
                                :src="itemData.show_cover"
                            />
                            <Icon
                                v-else
                                type="ios-add"
                                size="44"
                                color="#AEAEB3"
                            />
                        </div>
                    </FormItem>
                    <FormItem label="图片集：">
                        <div class="form_upload mb24" @click="openModal(0, 3)">
                            <Icon type="ios-add" size="40" color="#AEAEB3" />
                        </div>
                        <draggable
                            class="dragg_div"
                            v-model="itemData.show_imgs"
                            chosen-class="chosen"
                            force-fallback="true"
                            group="people"
                            animation="500"
                            :handle="'.dragg'"
                            @start="onStart"
                            @end="onEnd"
                        >
                            <div
                                v-for="(item, index) in itemData.show_imgs"
                                :key="index"
                            >
                                <div
                                    class="form_upload position_relative mr24 mb24 dragg"
                                >
                                    <Icon
                                        class="form_icon"
                                        size="20"
                                        type="ios-close-circle"
                                        color="#f00"
                                        @click="delImg(3, index)"
                                    />
                                    <img class="width_height_100" :src="item" />
                                </div>
                            </div>
                        </draggable>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button @click="cancelSampleModal">取消</Button>
                <Button
                    class="theme-bc theme-default-color"
                    @click="submitSampleModal"
                    >确定</Button
                >
            </div>
        </Modal>
        <!-- 选择模板 -->
        <Modal
            v-model="modals"
            :title="modalTitle"
            :width="modalWidth"
            :mask-closable="false"
        >
            <div>
                <template v-if="modalID == 2 || modalID == 1">
                    <Menu
                        mode="horizontal"
                        :active-name="formData.template_type"
                        @on-select="selectTemplate"
                    >
                        <MenuItem name="1">产品模板</MenuItem>
                        <MenuItem name="2">DIY模版</MenuItem>
                    </Menu>
                    <Table
                        class="mt24"
                        :columns="columnsTemplate"
                        :data="dataTemplate"
                        border
                    >
                        <template slot-scope="{ row }" slot="operate">
                            <div class="flex-sa">
                                <template v-if="formData.template_id == row.id">
                                    <div class="theme-color">使用中</div>
                                    <Button type="error" ghost @click="changeUsed(row)">取消</Button>
                                </template>
                                <Button
                                    v-else
                                    type="primary"
                                    ghost
                                   
                                    @click="changeUsing(row)"
                                    >使用</Button
                                >
                            </div>
                        </template>
                    </Table>
                    <div class="page_div">
                        <Page
                            :current="storeTemplate.page"
                            :page-size="storeTemplate.limit"
                            :total="totalTemplate"
                            show-elevator
                            show-total
                            @on-change="pageChangeTemplate"
                        />
                    </div>
                </template>
            </div>
            <div slot="footer"></div>
        </Modal>
        <!-- 产品属性(drawer) -->
        <Drawer v-model="attribute_drawer" title="产品属性" width="1000" class="attr-drawer">
            <div>
                <div style="display: flex">
                    <!-- left -->
                    <div 
                        style="
                            height: 80vh;
                            overflow-y: auto;
                            min-width: 375px;
                            width: 375px;
                            max-width: 375px;
                            background-color: #e8e8e8;
                            border-radius: 4px;
                        "
                    >
                        <div v-for="(e, indexs) in mainData" :key="indexs" @click="getDiyData(e, indexs)" :class="main_value == indexs ? 'main-content-active' : 'main-content'">
                            <div v-for="(items, index) in e.attribute_content.attribute_text" :key="index" class="attribute-text-div">
                                <div style="font-size: 18px; color: #000;display: flex;align-items: center;justify-content: center;padding-bottom: 6px;border-bottom: 1px solid #eee;">
                                    <div class="dec-left"></div>
                                    <div>{{ items.attribute_name ? items.attribute_name : "产品属性" }}</div>
                                    <div class="dec-right"></div>
                                </div>
                                <div v-if="items.attribute_content.length" style="font-size: 14px; color: #000" >
                                    <div v-for="(item, j) in items.attribute_content" :key="j" style="padding-top: 6px" >
                                        <div v-if="item.attribute_type == 6">
                                            <span style="font-size: 14px; color: #999" >{{ item.content_id }}：</span>
                                            <img v-if="item.attribute_content" :src="item.attribute_content" alt="" style="width: 100%;height: 148.8px;display: block;">
                                        </div>
                                        <template v-else>
                                            <span style="font-size: 14px; color: #999" >{{ item.content_id }}：</span>
                                            <span>{{ item.attribute_content }}</span>
                                        </template>
                                    </div>
                                </div>
                                <div v-else style="font-size: 14px; color: #000">
                                    <div style="padding-top: 6px"> <span style="font-size: 14px; color: #999" >属性名称：</span ><span>属性内容</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- right -->
                    <div style=" height: 80vh; overflow-y: auto; margin-left: 24px; " >
                        <Form label-position="left" :label-width="100">
                            <div v-for="(item, index) in diyData" :key="index"
                                style="
                                    margin-bottom: 12px;
                                    padding: 12px;
                                    border: 1px solid #ccc;
                                    border-radius: 4px;
                                    position: relative;
                                    background-color: #fff;
                                "
                            >
                                <img v-if="diyData.length > 1" src="@/assets/del_attr.png" @click="delAttribute(diyData, index)"
                                    style="
                                        position: absolute;
                                        top: 0;
                                        right: 0;
                                        width: 48px;
                                        height: 48px;
                                        cursor: pointer;
                                    "
                                />
                                <FormItem label="产品属性：" style="width: 90%" >
                                    <div style=" display: flex; align-items: center; " >
                                        <Select
                                            label-in-value
                                            v-model="item.attribute_id"
                                            clearable
                                            filterable
                                            placeholder="请选择产品属性"
                                            @on-change="
                                                changeAttribute(
                                                    diyData,
                                                    index,
                                                    $event
                                                )
                                            "
                                        >
                                            <Option
                                                v-for="it in attributeList"
                                                :value="it.id"
                                                :key="it.id"
                                                >{{ it.name }}</Option
                                            >
                                        </Select>
                                    </div>
                                </FormItem>
                                <FormItem
                                    v-if="item.attribute_name"
                                    style="margin-top: 12px; width: 90%"
                                >
                                    <div
                                        style="
                                            display: flex;
                                            align-items: center;
                                        "
                                    >
                                        <template
                                            v-if="
                                                name_style &&
                                                name_value == item.id
                                            "
                                        >
                                            <Input
                                                type="text"
                                                v-model="
                                                    item.attribute_name
                                                "
                                                placeholder="属性名称"
                                            ></Input>
                                            <Button
                                                type="primary"
                                                ghost
                                                style="margin-left: 24px"
                                                @click="
                                                    editNameStyle1(item)
                                                "
                                                >确定</Button
                                            >
                                        </template>
                                        <template v-else>
                                            <div>
                                                {{ item.attribute_name }}
                                            </div>
                                            <img
                                                src="@/assets/edit_name.png"
                                                alt=""
                                                style="
                                                    cursor: pointer;
                                                    margin-left: 24px;
                                                "
                                                @click="
                                                    editNameStyle2(item)
                                                "
                                            />
                                        </template>
                                    </div>
                                </FormItem>
                                <FormItem style="margin-top: 12px; width: 90%" >
                                    <div v-for="( ite, inde ) in item.attribute_content" :key="inde" >
                                        <div style="display: flex;align-items: center;justify-content: space-between;"
                                            class="mb12 position_relative width_100"
                                        >
                                            <Input style="width: 33%;margin-right: 24px;"
                                                type="text"
                                                v-model="ite.content_id"
                                                placeholder="产品属性名称"
                                            ></Input>
                                            <!-- 图片 -->
                                            <div v-if="ite.attribute_type == 6">
                                                <div class="form-upload"
                                                    @click="openModal(2, index, inde)"
                                                >
                                                    <img v-if="ite.attribute_content"
                                                        class="form-img"
                                                        :src="ite.attribute_content"
                                                    />
                                                    <div v-else class="flex-c form-img">
                                                        <img src="@/assets/upload_val.png"/>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- 复选框 -->
                                            <CheckboxGroup v-model="ite.attribute_content" v-else-if="ite.attribute_type == 5" style="width: 50%">
                                                <Checkbox v-for="(item, index) in ite.select_list" :value="item" :key="index" :label="item"></Checkbox>
                                            </CheckboxGroup>
                                            <!-- 单选框 -->
                                            <RadioGroup v-model="ite.attribute_content" v-else-if="ite.attribute_type == 4" style="width: 50%">
                                                <Radio v-for="(item, index) in ite.select_list" :value="item" :key="index" :label="item"></Radio>
                                            </RadioGroup>
                                            <!-- 下拉框 -->
                                            <Select v-else-if="ite.attribute_type == 3" v-model="ite.attribute_content" style="width: 50%">
                                                <Option v-for="(item, index) in ite.select_list" :value="item" :key="index">{{ item }}</Option>
                                            </Select>
                                            <!-- textarea -->
                                            <Input v-else-if="ite.attribute_type == 2" style="width: 50%"
                                                type="textarea"
                                                v-model="ite.attribute_content"
                                                :placeholder="ite.attribute_tips ? ite.attribute_tips : '请输入'"
                                            ></Input>
                                            <Input
                                                v-else
                                                style="width: 50%"
                                                type="text"
                                                v-model="ite.attribute_content"
                                                :placeholder="ite.attribute_tips ? ite.attribute_tips : '请输入'"
                                            ></Input>
                                            <Icon
                                                class="cursor-p"
                                                v-if="item.attribute_content.length > 1"
                                                type="ios-close-circle-outline"
                                                color="#FF4838"
                                                size="24"
                                                @click="
                                                    delAttributeContent(
                                                        inde,
                                                        item.attribute_content
                                                    )
                                                "
                                            />
                                        </div>
                                    </div>
                                    <Button
                                        class="theme-bc theme-default-color"
                                        icon="md-add-circle"
                                        @click="
                                            addAttributeContent(
                                                item.attribute_content
                                            )
                                        "
                                        >添加</Button
                                    >
                                </FormItem>
                            </div>
                            <Button class="theme-bc theme-default-color" icon="md-add-circle" @click="addAttribute(diyData)" >添加产品属性</Button >
                        </Form>
                    </div>
                </div>
                <div
                    style="
                        position: absolute;
                        left: 0;
                        bottom: 0;
                        padding: 24px;
                        background-color: #fff;
                        width: 100%;
                        text-align: center;
                        border-top: 1px solid #ccc;
                    "
                >
                    <Button @click="cancelAttributeDrawer">取消</Button>
                    <Button
                        style="margin-left: 12px"
                        class="theme-bc theme-default-color"
                        @click="submitAttributeDrawer"
                        >确定</Button
                    >
                </div>
            </div>
        </Drawer>
        <!-- 图片库 -->
        <pictureLibrary v-if="switch_modal" :switch_modal.sync="switch_modal" :select="imgtype" @change="costPlannedAmountChange"></pictureLibrary>
    </div>
</template>

<script>
import { product_list, product_save, product_info, template_result_template, template_diy_list, product_change_template, product_delete, 
    product_samplebook_list, product_samplebook_save, product_samplebook_del, product_reports, attr_page, page_attrs, save_page_attrs, 
    product_attribute_content_list, product_type_select, product_attribute_select } from "@/api/index";
import draggable from "vuedraggable";
import pictureLibrary from "@/components/pictureLibrary/pictureLibrary.vue";
import editor from "@/components/editor/editor.vue";
export default {
    components: { draggable, pictureLibrary, editor },
    data() {
        return {
            // 图片库参数
            srctype_inde: "",
            srctype: "",
            imgtype: 1,
            switch_modal: false,
            storePrams: {
                page: 1,
                limit: 10,
                name: "",
                type_id: -1,
            },
            total: 0,
            columnsTable: [
                { type: "selection", align: "center", width: 60 },
                { title: "产品图片", slot: "show_product_imgs", align: "center" },
                { title: "名称及规格", slot: "name", align: "center" },
                { title: "建议零售价", slot: "price", align: "center" },
                { title: "所属分类", slot: "type", align: "center" },
                { title: "使用模板", slot: "template_type", align: "center" },
                { title: "质检报告", slot: "show_report_imgs", align: "center" },
                { title: "产品样册", slot: "product_pic_count", align: "center" },
                { title: "产品属性", slot: "attribute_content", align: "center" },
                { title: "操作", slot: "operate", align: "center", width: "200px" },
            ],
            dataTable: [],
            reportModal: false,
            picModal: false,
            attributeModal: false,
            sampleModal: false,
            modals: false,
            modalTitle: "",
            modalWidth: "",
            modalID: "",
            typeList: [],
            drawers: false,
            drawerTitle: "",
            infoId: "",
            formData: {
                product_name: "",
                specs: "",
                warranty_days: "",
                content: "",
                price: "",
                type_id: "",
                template_id: "",
                first_query: "",
                not_first_query: "",
                excess_query: "",
                product_imgs: "",
                id: "",
                template_type: "1",
            },
            storeTemplate: {
                page: 1,
                limit: 10,
                industry_id: -1,
            },
            totalTemplate: 0,
            columnsTemplate: [
                { type: "index", width: 60, align: "center" },
                { title: "ID", key: "id", align: "center" },
                { title: "模板名称", key: "title", align: "center" },
                { title: "操作", slot: "operate", align: "center", width: "200px" },
            ],
            dataTemplate: [],
            itemData: {
                template_title: "",
                product_imgs: [],
                show_product_imgs: [],
                report_imgs: [],
                show_report_imgs: [],
                imgs: [],
                show_imgs: [],
                useValue: false,
                previewImg: "",
                show_cover: "",
            },
            formItem: {
                attribute_id: "",
            },
            attributeList: [],
            pagePic: {
                page: 1,
                limit: 10,
                product_id: "",
            },
            totalPic: 0,
            columnsPic: [
                { title: "样册名称", key: "title", align: "center" },
                { title: "封面图", slot: "show_cover", align: "center" },
                { title: "添加时间", key: "created_at", align: "center" },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "330px",
                },
            ],
            dataPic: [],
            formSample: {
                id: "",
                title: "",
                cover: "",
                imgs: "",
                product_id: "",
            },
            // selection
            del_id: "",
            delData: [],
            del_value: false,
            templateID: "",
            attributeData: {
                id: "",
                attribute_content: {},
            },
            reportData: {
                id: "",
                report_name: "",
                report_imgs: "",
            },
            imgview_icon: "",
            imgview: [],
            // attr
            attribute_drawer: false,
            name_style: false,
            name_value: "",
            baseUrl: "", // 存储当前域名
            columnsAttr: [
                { type: "index", width: 60, align: "center" },
                { title: "需设置页面", slot: "title", align: "center" },
                { title: "操作", slot: "operate", align: "center" },
            ],
            dataAttr: [],
            pageAttr: {
                page: 1,
                limit: 10,
                product_id: "",
            },
            totalAttr: 0,
            template_content_id: "",
            product_id: "",
            mainData: [],
            diyData: [],
            main_value: 0,
        };
    },
    mounted() {
        this.getList();
        this.getTypeList();
        // 产品属性下拉
        this.getAttributeSelect();
        // 在浏览器环境中获取当前域名
        this.baseUrl = window.location.origin;
    },
    methods: {
        getDiyData(item, index){
            this.diyData = item.attribute_content.attribute_text;
            this.main_value = index;
        },
        addAttribute(items) {
            items.push({
                attribute_id: "",
                attribute_name: "",
                attribute_content: [],
            });
        },
        addAttributeContent(item) {
            item.push({
                content_id: "",
                attribute_content: "",
                attribute_tips: "请输入",
                attribute_type: 1,
                attribute_val: "",
            });
        },
        delAttributeContent(index, e) {
            e.splice(index, 1);
        },
        editNameStyle1(item) {
            this.name_value = item.id;
            this.name_style = false;
        },
        editNameStyle2(item) {
            this.name_value = item.id;
            this.name_style = true;
        },
        changeAttribute(items, i, event) {
            if (event) {
                items[i].attribute_name = event.label;
                product_attribute_content_list({ id: event.value }).then((res) => {
                    var data = res.data;
                    data = res.data.map((item) => ({
                        content_id: item.attribute_name,
                        attribute_content: item.attribute_val,
                        attribute_tips: item.attribute_tips,
                        attribute_type: item.attribute_type,
                        attribute_val: item.attribute_val,
                        type_val: item.type_val,
                        select_list: item.type_val ? item.type_val.split('*') : []
                    }));
                    items[i].attribute_content = data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
            } else {
                items[i].attribute_name = "";
                items[i].attribute_content = [
                    {
                        attribute_content: "",
                        attribute_tips: null,
                        attribute_type: 1,
                        content_id: "",
                        attribute_val: "",
                        type_val: "",
                    },
                ];
            }
        },
        delAttribute(items, index) {
            items.splice(index, 1);
        },
        attr_page() {
            attr_page(this.pageAttr)
                .then((res) => {
                    this.dataAttr = res.data.data;
                    this.totalAttr = res.data.total;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        cancelAttributeDrawer() {
            this.attribute_drawer = false;
        },
        submitAttributeDrawer() {
            const data = {
                attribute_json: this.mainData.map((item) => ({
                    attribute_text: item.attribute_content.attribute_text,
                    product_id: this.product_id,
                    key: item.key,
                    template_content_id: item.template_content_id,
                })),
            };
            save_page_attrs(data)
                .then((res) => {
                    this.getList();
                    this.attribute_drawer = false;
                    this.name_style = false;
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        page_attrs() {
            var data = {
                template_content_id: this.template_content_id,
                product_id: this.product_id,
            };
            page_attrs(data).then((res) => {
                    this.mainData = res.data.map((item) => {
                        // 获取attribute_content对象
                        const attrContent = item.attribute_content;
                        // 获取attribute_text属性（处理undefined情况）
                        const attrText = attrContent?.attribute_text;
                        // 检查是否需要替换值
                        if (
                            // 空字符串
                            attrText === "" ||
                            // null或undefined
                            attrText == null ||
                            // 字符串"bull"
                            attrText === "bull" ||
                            // 空对象 {}
                            (typeof attrText === "object" &&
                                Object.keys(attrText).length === 0)
                        ) {
                            // 创建新对象避免引用污染
                            const newContent = { ...attrContent };
                            // 使用Vue.set确保响应式
                            this.$set(newContent, "attribute_text", [
                                {
                                    attribute_id: "",
                                    attribute_name: "",
                                    attribute_content: [],
                                },
                            ]);
                            // 返回修改后的对象
                            return { ...item, attribute_content: newContent };
                        }
                        // 无需修改的直接返回
                        return item;
                    });
                    console.log("mainData:", this.mainData);
                    this.diyData = this.mainData[0].attribute_content.attribute_text;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        goAttr(row) {
            this.template_content_id = row.template_content_id;
            this.page_attrs();
            setTimeout(() => {
                this.attribute_drawer = true;
            }, 300);
        },
        // 事件处理函数
        async costPlannedAmountChange(param1, param2) {
            if (this.imgtype == 0 && this.srctype == 1) {
                for (var i = 0; i < param1.length; i++) {
                    this.itemData.show_product_imgs.push(param1[i]);
                }
                for (var i = 0; i < param2.length; i++) {
                    this.itemData.product_imgs.push(param2[i]);
                }
                this.$Message.destroy();
            } else if (this.imgtype == 0 && this.srctype == 2) {
                for (var i = 0; i < param1.length; i++) {
                    this.itemData.show_report_imgs.push(param1[i]);
                }
                for (var i = 0; i < param2.length; i++) {
                    this.itemData.report_imgs.push(param2[i]);
                }
                this.$Message.destroy();
            } else if (this.imgtype == 0 && this.srctype == 3) {
                for (var i = 0; i < param1.length; i++) {
                    this.itemData.show_imgs.push(param1[i]);
                }
                for (var i = 0; i < param2.length; i++) {
                    this.itemData.imgs.push(param2[i]);
                }
                this.$Message.destroy();
            } else if (this.imgtype == 1) {
                for (var i = 0; i < param1.length; i++) {
                    this.itemData.show_cover = param1[i];
                }
                for (var i = 0; i < param2.length; i++) {
                    this.formSample.cover = param2[i];
                }
                this.$Message.destroy();
            } else if (this.imgtype == 2) {
                for (var i = 0; i < param1.length; i++) {
                    this.diyData[this.srctype].attribute_content[this.srctype_inde].attribute_content = param1[i];
                }
                this.$Message.destroy();
            }
        },
        openModal(e, index, inde) {
            this.imgtype = e;
            this.srctype = index;
            this.srctype_inde = inde;
            this.switch_modal = true;
        },
        // 产品样册列表
        geSampleBookList() {
            product_samplebook_list(this.pagePic)
                .then((res) => {
                    this.dataPic = res.data.data;
                    this.totalPic = res.data.total;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        getAttributeSelect() {
            product_attribute_select()
                .then((res) => {
                    this.attributeList = res.data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        // 移动时
        onStart(e) {
            this.drag = true;
            console.log("触发移动", e);
        },
        // 移动结束
        onEnd(e) {
            this.drag = false;
            console.log("移动结束", e);
        },
        getList() {
            product_list(this.storePrams)
                .then((res) => {
                    this.dataTable = res.data.data;
                    this.total = res.data.total;
                    // 删除后，page--
                    if(!res.data.data.length && this.storePrams.page != 1){
                        this.storePrams.page --;
                        this.getList();
                    }
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        // 获取产品分类下拉
        getTypeList() {
            product_type_select()
                .then((res) => {
                    this.typeList = res.data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        goSearch(){
            this.storePrams.page = 1;
            this.getList();
        },
        pageChangeTemplate(index) {
            this.storeTemplate.page = index;
            if (this.formData.template_type == 1) {
                this.getTemplateList();
            } else if (this.formData.template_type == 2) {
                this.getDiyList();
            }
        },
        pageChangePic(index) {
            this.pagePic.page = index;
            this.getSampleList();
        },
        pageChangeAttr(index) {
            this.pageAttr.page = index;
            this.attr_page();
        },
        // 详情
        getInfo() {
            product_info({ id: this.infoId })
                .then((res) => {
                    this.formData.id = res.data.id;
                    this.formData.product_name = res.data.product_name;
                    this.formData.specs = res.data.specs;
                    this.formData.warranty_days = res.data.warranty_days;
                    this.formData.content = res.data.content;
                    this.formData.price = res.data.price;
                    this.formData.type_id = res.data.type_id;
                    this.formData.template_id = res.data.template_id;
                    this.formData.first_query = res.data.first_query;
                    this.formData.not_first_query = res.data.not_first_query;
                    this.formData.excess_query = res.data.excess_query;
                    this.formData.product_imgs = res.data.product_imgs;
                    this.formData.template_type = res.data.template_type + "";
                    if (res.data.template_type == 0) {
                        this.formData.template_type = "1";
                    }
                    this.itemData.template_title = res.data.template.title;
                    if(res.data.product_imgs.length){
                        var product_imgs = res.data.product_imgs;
                        this.itemData.product_imgs = product_imgs.split(",");
                    }else{
                        this.itemData.product_imgs = []
                    }
                    this.itemData.show_product_imgs =
                        res.data.show_product_imgs;
                    if (res.data.report_imgs) {
                        var report_imgs = res.data.report_imgs;
                        this.itemData.report_imgs = report_imgs.split(",");
                    }else{
                        this.itemData.report_imgs = []
                    }
                    this.itemData.show_report_imgs = res.data.show_report_imgs;
                    this.reportData.report_name = res.data.report_name;
                    this.reportData.report_imgs = res.data.report_imgs;
                    if (this.modalID == 2 || this.modalID == 1) {
                        if (this.formData.template_type == 1) {
                            this.getTemplateList();
                        } else if (this.formData.template_type == 2) {
                            this.getDiyList();
                        }
                    }
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        // 模板列表
        getTemplateList() {
            template_result_template(this.storeTemplate)
                .then((res) => {
                    this.dataTemplate = res.data.data;
                    this.totalTemplate = res.data.total;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        getDiyList() {
            template_diy_list(this.storeTemplate)
                .then((res) => {
                    this.dataTemplate = res.data.data;
                    this.totalTemplate = res.data.total;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        goDrawer(row) {
            this.drawers = true;
            this.$nextTick(() => {
                if (row.id) {
                    this.drawerTitle = "编辑产品";
                    // 详情
                    this.infoId = row.id;
                    this.getInfo();
                } else {
                    this.drawerTitle = "新增产品";
                    this.infoId = "";
                    this.formData.id = "";
                    this.formData.product_name = "";
                    this.formData.specs = "";
                    this.formData.warranty_days = "";
                    this.formData.content = "";
                    this.formData.price = "";
                    this.formData.type_id = "";
                    this.formData.template_id = "";
                    this.formData.product_imgs = "";
                    this.itemData.template_title = "";
                    this.itemData.product_imgs = [];
                    this.itemData.show_product_imgs = [];
                    this.formData.template_type = "1";
                    this.formData.first_query =
                        '<h3><span style="color: rgb(0, 138, 0);">本次为首次查询验证，</span></h3><p>防伪编码：{#q}，</p><p>您查询的是正品，感谢您选择我们的产品</p>';
                    this.formData.not_first_query =
                        '<h3><span style="color: rgb(0, 102, 204);">多次查询，请确保是您本人查询，</span></h3><p>防伪编码：{#q}，</p><p>您查询的是本公司正品。本次为第{#s}次查询，</p><p>首次查询时间：{#t}</p>';
                    this.formData.excess_query =
                        '<h3><span style="color: rgb(230, 0, 0);">该码查询次数过多，已被系统锁定，</span></h3><p>防伪编码：{#q}</p>';
                    this.getTemplateList();
                }
            });
        },
        // selection
        changeSelection(e) {
            this.delData = e;
            if (this.dataTable.length === e.length) {
                this.del_value = true;
            } else {
                this.del_value = false;
            }
        },
        handleSelectAll(e) {
            if (e == true) {
                this.delData = this.dataTable;
                this.$refs.selection.selectAll(true);
            } else {
                this.$refs.selection.selectAll(false);
            }
        },
        goReport(row) {
            this.infoId = row.id;
            this.getInfo();
            this.reportData.id = row.id;
            setTimeout(() => {
                this.reportModal = true;
            }, 300);
        },
        goPic(row) {
            this.pagePic.product_id = row.id;
            this.geSampleBookList();
            this.formSample.product_id = row.id;
            setTimeout(() => {
                this.picModal = true;
            }, 300);
        },
        goAttribute(row) {
            this.product_id = row.id;
            this.pageAttr.product_id = row.id;
            this.attr_page();
            setTimeout(() => {
                this.attributeModal = true;
            }, 300);
        },
        goAddSample(row) {
            if (row.id) {
                this.formSample.id = row.id;
                this.formSample.title = row.title;
                this.formSample.cover = row.cover;
                this.itemData.show_cover = row.show_cover;
                this.formSample.imgs = row.imgs;
                this.itemData.show_imgs = row.show_imgs;
                var imgs = row.imgs;
                this.itemData.imgs = imgs.split(",");
            } else {
                this.formSample.id = "";
                this.formSample.title = "";
                this.formSample.cover = "";
                this.itemData.show_cover = "";
                this.formSample.imgs = "";
                this.itemData.show_imgs = [];
                this.itemData.imgs = [];
            }
            setTimeout(() => {
                this.sampleModal = true;
            }, 200);
        },
        goModal(index, row) {
            this.modalID = index;
            if (index == 1) {
                this.modalTitle = " ";
                this.modalWidth = 60;
                this.infoId = row.id;
                this.getInfo();
                this.formData.id = row.id;
            } else if (index == 2) {
                this.modalTitle = " ";
                this.modalWidth = 60;
                if (row.id) {
                    this.infoId = row.id;
                    this.getInfo();
                    this.formData.id = row.id;
                }
            }
            setTimeout(() => {
                this.modals = true;
            }, 750);
        },
        cancelReportModal() {
            this.reportModal = false;
        },
        submitReportModal() {
            this.reportData.report_imgs = this.itemData.report_imgs.join(",");
            product_reports(this.reportData)
                .then((res) => {
                    this.getList();
                    this.reportModal = false;
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        cancelSampleModal() {
            this.sampleModal = false;
        },
        submitSampleModal() {
            this.formSample.imgs = this.itemData.imgs.join(",");
            product_samplebook_save(this.formSample)
                .then((res) => {
                    this.geSampleBookList();
                    this.getList();
                    this.sampleModal = false;
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        cancelDrawer() {
            this.drawers = false;
        },
        // 确定
        submitDrawer() {
            this.formData.product_imgs = this.itemData.product_imgs.join(",");
            product_save(this.formData)
                .then((res) => {
                    this.getList();
                    this.drawers = false;
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        changeUsing(row) {
            this.$Modal.confirm({
                title: "提示",
                content: "确认改变使用状态吗？",
                onOk: () => {
                    this.formData.template_id = row.id;
                    this.itemData.template_title = row.title;
                    if (this.modalID == 1) {
                        const data = {
                            product_id: this.formData.id,
                            template_id: this.formData.template_id,
                            template_type: this.formData.template_type,
                        };
                        product_change_template(data).then((res) => {
                            this.getList();
                            this.modals = false;
                            this.$Message.success(res.msg);
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        });
                    } else if (this.modalID == 2) {
                        this.modals = false;
                        this.drawers = true;
                    }
                },
                onCancel: () => {},
            });
        },
        changeUsed(row) {
            this.$Modal.confirm({
                title: "提示",
                content: "确认取消使用状态吗？",
                onOk: () => {
                    this.formData.template_id = row.id;
                    this.itemData.template_title = row.title;
                    const data = {
                        product_id: this.formData.id,
                        template_id: 0,
                        template_type: this.formData.template_type,
                    };
                    product_change_template(data).then((res) => {
                        this.getList();
                        this.modals = false;
                        this.$Message.success(res.msg);
                    })
                    .catch((res) => {
                        this.$Message.error(res.msg);
                    });
                },
                onCancel: () => {},
            });
        },
        goDel(index, row) {
            if (index == 0 && this.delData.length == 0) {
                this.$Message.error("请选择");
                return;
            }
            this.$Modal.confirm({
                title: "删除提示",
                content: "确认删除吗？一经删除无法复原",
                onOk: () => {
                    if (index == 0) {
                        var del_id = [];
                        this.delData.forEach((item) => {
                            del_id.push(item.id);
                        });
                        this.del_id = del_id.join(",");
                        product_delete({ id: this.del_id })
                            .then((res) => {
                                this.getList();
                                this.$Message.success(res.msg);
                            })
                            .catch((res) => {
                                this.$Message.error(res.msg);
                            });
                    } else if (index == 1) {
                        product_delete({ id: row.id })
                            .then((res) => {
                                this.getList();
                                this.$Message.success(res.msg);
                            })
                            .catch((res) => {
                                this.$Message.error(res.msg);
                            });
                    } else if (index == 2) {
                        product_samplebook_del({ id: row.id })
                            .then((res) => {
                                this.geSampleBookList();
                                this.getList();
                                this.$Message.success(res.msg);
                            })
                            .catch((res) => {
                                this.$Message.error(res.msg);
                            });
                    }
                },
                onCancel: () => {},
            });
        },
        selectTemplate(name) {
            this.formData.template_type = name;
            if (name == 1) {
                this.getTemplateList();
            } else if (name == 2) {
                this.getDiyList();
            }
        },
        delImg(e, index) {
            if (e == 1) {
                this.itemData.product_imgs.splice(index, 1);
                this.itemData.show_product_imgs.splice(index, 1);
            } else if (e == 2) {
                this.itemData.report_imgs.splice(index, 1);
                this.itemData.show_report_imgs.splice(index, 1);
            } else if (e == 3) {
                this.itemData.show_imgs.splice(index, 1);
                this.itemData.imgs.splice(index, 1);
            }
        },
        //富文本
        getEnContentchange1(detailData) {
            this.formData.first_query = detailData.editorData;
        },
        getEnContent1(detailData) {
            this.formData.first_query = detailData.editorData;
        },
        getEnContentchange2(detailData) {
            this.formData.not_first_query = detailData.editorData;
        },
        getEnContent2(detailData) {
            this.formData.not_first_query = detailData.editorData;
        },
        getEnContentchange3(detailData) {
            this.formData.excess_query = detailData.editorData;
        },
        getEnContent3(detailData) {
            this.formData.excess_query = detailData.editorData;
        },
        openImg(item){
            if(item){
                window.open(item);
            }else{
                this.$Message.error('请先上传图片');
            }
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.header {
    padding: 24px 24px 0 24px;
    margin-bottom: 24px;
    background-color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    height: 100%;
}
.page {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
}
.page_div {
    margin-top: 24px;
    text-align: right;
    white-space: nowrap;
}
.table_picture {
    margin: 12px 0;
    width: 60px;
    height: 60px;
}
.form_upload {
    width: 70px;
    height: 70px;
    background: #ffffff;
    border-radius: 5px;
    border: 1px dashed #9fa5bb;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}
::v-deep .ivu-menu.ivu-menu-light.ivu-menu-horizontal {
    display: flex;
    align-items: center;
    justify-content: space-around;
}
::v-deep .ivu-menu-item {
    font-size: 16px;
}
::v-deep .ivu-menu-item:hover {
    font-size: 16px;
    color: #FF761D  !important;
    border-bottom: 2px solid #FF761D  !important;
}
::v-deep .ivu-menu-item.ivu-menu-item-active.ivu-menu-item-selected {
    color: #FF761D ;
    font-size: 16px;
    border-bottom: 2px solid #FF761D  !important;
}
::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #FF761D ;
    background-color: #FF761D ;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
.dragg_div {
    display: flex;
    flex-wrap: wrap;
}
.position_relative {
    position: relative;
}
.form_icon {
    position: absolute;
    top: -10px;
    right: -10px;
}
.width_800 {
    width: 800px;
}
.form_div {
    display: flex;
    align-items: center;
}
.form_title {
    color: #484e66;
    font-weight: bold;
}
.width_100 {
    width: 100%;
}
.width_30 {
    width: 30%;
}
.width_60 {
    width: 60%;
}
.width_height_100 {
    width: 100%;
    height: 100%;
}
.ta-r {
    text-align: right;
}
.checkbox-ml {
    margin-left: 20px !important;
}
.attr-drawer ::v-deep .ivu-drawer-mask {
    z-index: 2000 !important;
}
.attr-drawer ::v-deep .ivu-drawer-wrap {
    z-index: 2000 !important;
}
.dec-left {
    margin: 0 12px;
    width: 50px;
    height: 4px;
    border-radius: 2px;
    background: linear-gradient(to left, #FF761D , transparent);
}

.dec-right {
    margin: 0 12px;
    width: 50px;
    height: 4px;
    border-radius: 2px;
    background: linear-gradient(to right, #FF761D , transparent);
}
.main-content {
    background-color: #fff;
    margin-top: 6px;
    cursor: pointer;
    border: 2px solid #eee;
}
.main-content-active {
    background-color: #fff;
    margin-top: 6px;
    cursor: pointer;
    border: 2px dashed #FF761D ;
}
.form-upload {
    width: 80px;
    height: 80px;
    cursor: pointer;
    border-radius: 4px;
}
.form-img {
    width: 100%;
    height: 100%;
    border: 1px solid #eee;
    border-radius: 4px;
}
.attribute-text-div {
    padding: 6px 6px 12px 6px;
}
.attribute-text-div:last-child {
    padding: 6px;
}
.br-5 {
    border-radius: 5px;
}
/* RadioGroup */
::v-deep .ivu-radio-checked .ivu-radio-inner {
    border-color: #FF761D ;
}
::v-deep .ivu-radio-inner:after {
    background-color: #FF761D ;
}
.cursor-p {
    cursor: pointer;
}
</style>